module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/make-video_2-e385c561a1d36f1637ae4a7da833c75e.png";